<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <div class="search"
         style="margin-top:7px">
      <!-- 选取文件 -->
      <el-upload class="upload-demo"
                 ref="upload"
                 :headers="myHeader"
                 :action="uploadUrl"
                 :on-preview="handlePreview"
                 :on-remove="handleRemove"
                 :on-success="handleSuccess"
                 :before-upload="beforeExcelUpload"
                 :file-list="fileList"
                 :auto-upload="false">
        <el-button slot="trigger"
                   class="el-button-columnBtn"
                   style="margin-bottom: 7px">选取文件</el-button>
        <el-button class="el-button-columnBtn"
                   style="margin-bottom: 7px; margin-left:7px"
                   @click="submitUpload">上传到服务器</el-button>
        <div slot="tip"
             class="el-upload__tip">文件不得超过20MB</div>
      </el-upload>
      <el-button class="el-button-columnBtn"
                 @click="deleteHandle()"
                 style="margin-top:7px"
                 :disabled="dataListSelections.length <= 0">删除</el-button>
    </div>
    <div class="table-user table"
         style="margin-top:15px;">
      <el-table :data="dataList"
                v-loading="dataListLoading"
                border
                style="width: 100%"
                @selection-change="selectionChangeHandle">
        <el-table-column type="selection"
                         header-align="center"
                         align="center"
                         width="70">
        </el-table-column>
        <!-- 文件名 -->
        <el-table-column prop="attachmentName"
                         label="文件名"
                         width="250"
                         show-overflow-tooltip
                         header-align="center">
          <template slot-scope="scope">
            <span class="el-dropdown-link"
                  role="button"
                  tabindex="0"
                  @click="downLoadPage(`${scope.row.mailAttachmentId}`,scope.row.attachmentName)">
              {{ scope.row.attachmentName }}</span>
          </template>
        </el-table-column>
        <!-- 文件大小 -->
        <el-table-column prop="attachmentSize"
                         label="文件大小"
                         width="200"
                         show-overflow-tooltip
                         header-align="center">
        </el-table-column>
        <!-- 上传时间 -->
        <el-table-column prop="createTime"
                         label="上传时间"
                         show-overflow-tooltip
                         header-align="center">
        </el-table-column>
      </el-table>
    </div>
    <el-button class="el-button-columnBtn"
               style="margin-top:15px"
               @click="back">返回</el-button>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      // 获取列表信息
      mixinViewModuleOptions: {
        getDataListURL: `/sys/commmail/searchAttachment`,
        getDataListIsPage: true,
        activatedIsNeed: false
      },
      dataForm: {
        mailId: '',
        attachmentName: ''
      },
      myHeader: { token: '' }, // token
      upload: '',
      dataList: [],
      dataListLoading: false,
      fileList: [],
      url: '/sys/commmail/uploadAttachment',
      uploadUrl: '',
      token: '',
      hasError: false,
      dataListSelections: []
    }
  },
  activated() {
    this.dataForm = {}
    if (this.$route.query.mailId !== undefined && this.$route.query.mailId !== '' && this.$route.query.mailId !== null) {
      this.dataForm.mailId = this.$route.query.mailId
      // this.uploadUrl = `${window.SITE_CONFIG['apiURL']}` + this.url + `?token=${this.getStorage(this.GLOBAL.TOKEN)}` + `&mailId=${this.$route.query.mailId}`
      this.uploadUrl = `${window.SITE_CONFIG['apiURL']}` + this.url + `&mailId=${this.$route.query.mailId}`
      this.myHeader.token = this.getStorage(this.GLOBAL.TOKEN)
      this.getDataList()
    }
  },
  methods: {
    submitUpload(file, fileList) {
      this.fileList.mailId = this.dataForm.mailId
      this.$refs.upload.submit()
    },
    handleRemove(file, fileList) {
      console.log(file)
    },
    handlePreview(file) {
      console.log(file)
    },
    beforeExcelUpload(file, fileList) {
      let maxLength = 20 * 1024 * 1024
      if (file.size > maxLength) {
        this.$message({
          message: '文件大小不能超过20M',
          type: 'error',
          duration: 1500,
          onClose: () => {
            this.getDataList()
          }
        })
        return false
      }
      return true
    },
    // 上传成功
    handleSuccess(response, file, fileList) {
      this.fileList = []
      this.getDataList()
    },
    // 下载
    downLoadPage(url, name) {
      let upimgurl = `/sys/commmail/downloadAttachment?mailAttachmentId=${url}`
      this.$request.download(upimgurl, name, null, null, 'email')
    },
    // 选择删除id
    selectionChangeHandle(val) {
      this.dataListSelections = val
    },
    // 批量删除
    deleteHandle(id) {
      let ids = id ? [id] : this.dataListSelections.map(item => {
        return item.mailAttachmentId
      })
      this.$confirm(this.$t('user.delet'), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.$request.post(`/sys/commmail/deleteAttachment`,
          {
            attachmentIds: ids + '',
            mailId: this.$route.query.mailId
          }
        ).then(() => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.getDataList()
            }
          })
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    back() {
      this.$router.push({
        name: 'sys-sendmail',
        query: {
          mailId: this.dataForm.mailId
        }
      })
    }
  },
  created() {
    console.log('created')
  }
}
</script>

<style lang="scss" scoped>
.search {
  width: 50% !important;
}
</style>
